<template>
  <el-dialog
    title="试题预览"
    :visible.sync="visible"
    width="800px"
    top="5vh"
    append-to-body
    custom-class="question-preview-dialog"
  >
    <div v-if="questionData" class="preview-container">
      <div class="meta-header">
        <el-tag size="small" type="primary" effect="dark">{{ questionData.subject }}</el-tag>
        <el-tag size="small" type="success" effect="plain" class="ml-10">{{ questionData.typeStr }}</el-tag>
        <el-tag size="small" type="warning" effect="plain" class="ml-10">难度：{{ questionData.level }}</el-tag>
        <span class="id-text">ID: {{ questionData.questionId }}</span>
      </div>

      <el-divider />

      <div v-if="questionData.type !== 5" class="normal-question-zone">
        <div class="question-content">{{ questionData.content }}</div>

        <div v-if="questionData.options && questionData.options.length" class="options-list">
          <div
            v-for="opt in questionData.options"
            :key="opt.option"
            :class="['option-item', { 'is-correct': opt.correct }]"
          >
            <span v-if="opt.correct" class="option-tag">
              <i class="el-icon-check" /> 正确答案
            </span>
            <div class="option-text">{{ opt.content }}</div>
          </div>
        </div>
      </div>

      <div v-else class="composite-question-zone">
        <div class="material-title"><i class="el-icon-document" /> 阅读材料/题干：</div>
        <div class="question-content material-box">{{ questionData.content }}</div>

        <div class="sub-questions-title"><i class="el-icon-edit" /> 子题集 (共 {{ questionData.children.length }} 题)：</div>

        <div
          v-for="(sub, index) in questionData.children"
          :key="sub.questionId"
          class="sub-question-item"
        >
          <div class="sub-content">
            <span class="sub-index">({{ index + 1 }})</span>
            <span class="sub-text">{{ sub.content }}</span>
          </div>

          <div v-if="sub.options && sub.options.length" class="sub-options-grid">
            <div
              v-for="subOpt in sub.options"
              :key="subOpt.option"
              :class="['sub-option-cell', { 'sub-correct': subOpt.correct }]"
            >
              <span class="cell-text">{{ subOpt.content }}</span>
              <el-badge v-if="subOpt.correct" value="正确" class="correct-badge" type="success" />
            </div>
          </div>
        </div>
      </div>

      <el-divider content-position="left"><span class="section-title">答案解析</span></el-divider>

      <div class="analysis-box">
        <div class="analysis-text">{{ questionData.analysis || '暂无解析' }}</div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭预览</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExamQuestionPreview',
  data() {
    return {
      visible: false,
      questionData: null
    }
  },
  methods: {
    /**
     * 外部父组件调用的打开方法
     * @param {Object} data 后端返回的完整 data 对象
     */
    open(data) {
      this.questionData = data
      this.visible = true
    }
  }
}
</script>

<style scoped>
/* 保持文本本身的空格与换行，这对于K12和高考题目的排版至关重要 */
.question-content, .analysis-text, .option-text {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 15px;
  line-height: 1.6;
  color: #303133;
}

.ml-10 {
  margin-left: 10px;
}

.meta-header {
  display: flex;
  align-items: center;
}

.id-text {
  margin-left: auto;
  font-size: 12px;
  color: #909399;
}

/* 常规单选题样式 */
.options-list {
  margin-top: 15px;
}

.option-item {
  padding: 12px 15px;
  margin-bottom: 10px;
  background-color: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s;
}

.option-item.is-correct {
  background-color: #f0f9eb;
  border-color: #c2e7b0;
}

.option-tag {
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 12px;
  color: #67c23a;
  font-weight: bold;
}

/* 组合题/完型填空特定样式 */
.material-title, .sub-questions-title {
  font-weight: bold;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.sub-questions-title {
  margin-top: 25px;
}

.material-box {
  background-color: #fdfdfd;
  border: 1px dashed #dcdfe6;
  padding: 15px;
  border-radius: 6px;
  max-height: 260px;
  overflow-y: auto;
}

.sub-question-item {
  background: #fafafa;
  border: 1px solid #ebeef5;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.sub-content {
  font-weight: bold;
  margin-bottom: 8px;
}

.sub-index {
  color: #409eff;
  margin-right: 5px;
}

/* 子题选项的网格平铺布局（1行4个选项） */
.sub-options-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.sub-option-cell {
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.sub-option-cell.sub-correct {
  border-color: #67c23a;
  background-color: #f0f9eb;
  color: #67c23a;
  font-weight: bold;
}

.correct-badge >>> .el-badge__content {
  scale: 0.8;
}

/* 解析区样式 */
.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #e6a23c;
}

.analysis-box {
  background-color: #fff8ee;
  border-left: 4px solid #e6a23c;
  padding: 12px 15px;
  border-radius: 0 4px 4px 0;
}
</style>
